
export enum OperatorRoles {
  BLASTER = 1,
  OPERATOR = 2
}